import { inject, Injectable } from '@angular/core';
import { IxNgBusyFormService, IxParentDTO, IxServiceBaseUtil } from 'ix-ng-components';
import { Observable, ReplaySubject } from 'rxjs';
import { BROWSERS, DeviceDetectorService } from 'ngx-device-detector';
import { IxNgErrorHandlingService } from 'ix-ng-forms';
import { IxKeycloakHttp, IxNgHttpService } from 'ix-ng-http';
import { IxNgRoutingService } from 'ix-ng-routing';
import { BaseAppService } from '../services/base-app.service';
import { ComVizitkaDTO } from './vizitka.model';
import { Maybe, UndefinedOrNull } from 'ix-ng-static-utils';

@Injectable({
  providedIn: 'root',
})
export class VizitkaService {
  private readService: IxServiceBaseUtil;
  public data: IxParentDTO<ComVizitkaDTO> | undefined;
  public browser: string;
  public browserVersion: string;
  public splAplBuild: string | undefined;
  public splAplVersion: string | undefined;

  private _vizitka: ReplaySubject<string> = new ReplaySubject<string>(1);

  protected ixKeycloakHttp = inject(IxKeycloakHttp);
  protected ixNgRoutingService = inject(IxNgRoutingService);
  protected ixNgErrorHandlingService = inject(IxNgErrorHandlingService);
  protected ixNgHttpService = inject(IxNgHttpService);
  protected ixNgBusyFormService = inject(IxNgBusyFormService);

  constructor() {
    const comAppService = inject(BaseAppService);
    const deviceService = inject(DeviceDetectorService);

    this.readService = new IxServiceBaseUtil(
      this.ixKeycloakHttp,
      this.ixNgRoutingService,
      this.ixNgErrorHandlingService,
      this.ixNgHttpService,
      this.ixNgBusyFormService,
    );

    this.readService.serviceUrl = BaseAppService.controllerUrl + '/ComVizitka';

    this.readVizitka();

    // Spletna aplikacija
    this.readService.safeCall(
      () => comAppService.getAppVersion(),
      (result: { version: string | undefined } | UndefinedOrNull) => {
        const jsonVersion: string | undefined = result?.version; /* { version: string } */
        const versions: string[] | undefined = jsonVersion?.split('.');
        if (versions && versions.length >= 5) {
          this.splAplVersion = versions[0] + '.' + versions[1] + '.' + versions[2];
          this.splAplBuild = versions[3] + '.' + versions[4];
          this._vizitka.next('getAppVersion');
        }
      },
    );

    // Verzija brskalnika
    deviceService.getDeviceInfo();
    this.browserVersion = deviceService.browser_version;
    switch (deviceService.browser) {
      case BROWSERS.CHROME: {
        this.browser = 'Chrome';
        break;
      }
      case BROWSERS.FIREFOX: {
        this.browser = 'Mozilla Firefox';
        break;
      }
      case BROWSERS.IE: {
        this.browser = 'Internet Explorer';
        break;
      }
      case BROWSERS.MS_EDGE:
      case BROWSERS.MS_EDGE_CHROMIUM: {
        this.browser = 'Microsoft Edge';
        break;
      }
      case BROWSERS.SAFARI: {
        this.browser = 'Safari';
        break;
      }
      case BROWSERS.OPERA: {
        this.browser = 'Opera';
        break;
      }
      default: {
        this.browser = 'Neznano';
        break;
      }
    }
  }

  readVizitka() {
    this.readService.safeCall(
      () => this.readService.get('readVizitka', undefined),
      (result: Maybe<IxParentDTO<ComVizitkaDTO>>) => {
        if (result) {
          this.data = result;
          this._vizitka.next('readVizitka');
        }
      },
    );
  }

  get vizitka(): Observable<string> {
    return this._vizitka.asObservable();
  }
}
